module.exports = __webpack_public_path__ + "img/NatalieHeintzenberg_140x140.8cf3caae.jpg";